module.exports = __webpack_public_path__ + "static/media/splash_5.5a21fb6f.webp";